import { Container, Row, Col, Card, Button, Form, Table, InputGroup, Badge, Spinner } from 'react-bootstrap';
import { useEffect, useState, useContext } from 'react';
import { useFirebaseConnection } from '../../services/useFirebaseConnection';
import { getDoc, collection, query, where, getDocs, doc } from 'firebase/firestore';
import { sendMessage } from '../../scripts/sendMessage';
import { AuthContext } from '../../contexts/AuthContext';
import { 
  FaTachometerAlt, 
  FaUsers, 
  FaFileInvoiceDollar, 
  FaFileContract, 
  FaMoneyBillWave,
  FaBars,
  FaTimes,
  FaClipboardList,
  FaUser,
  FaDesktop,
  FaWhatsapp
} from 'react-icons/fa';

export default function TeamZap() {

    const [teamZapStatus, setTeamZapStatus] = useState(false);
    const [temZapData, setTeamZapData] = useState();
    const { db } = useFirebaseConnection();
    const {user} = useContext(AuthContext)

    useEffect(() => {
        async function getTeamZapData() {
        try {
            const userDocRef = collection(db, 'users');
            const q = query(userDocRef, where('email', '==', user.email));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
            console.log('Nenhum usuário encontrado com esse e-mail.');
            return;
            }

            const filterUser = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
            }));

            setTeamZapData(filterUser[0]);
            
            setTeamZapStatus(true)

        } catch (error) {
            console.error('Erro ao buscar dados do usuário:', error);
        }
        }


        getTeamZapData()



    }, []);

async function fetchPendingInstallments() {
  const pedidoRef = collection(db, 'pedidos');
  const q = query(pedidoRef, where('status', '==', 'ativo'));
  const querySnapshot = await getDocs(q);

  const pedidosComParcelasNaoPagas = querySnapshot.docs.filter(doc => {
    const parcelas = doc.data().parcelas || [];
    return parcelas.some(parcela => parcela.pago === false);
  });

  for (const pedidoDoc of pedidosComParcelasNaoPagas) {
  const data = pedidoDoc.data();
  const clienteId = data.clienteId;

  if (!clienteId) continue;

  const clienteDocRef = doc(db, 'clientes', clienteId); // agora funciona
  const clienteSnap = await getDoc(clienteDocRef);

  if (!clienteSnap.exists()) continue;

  const clienteData = clienteSnap.data();
  const clienteNome = clienteData.nome || "Cliente";
  const numero = clienteData.telefone || "";

  const parcelasPendentes = data.parcelas.filter(p => p.pago === false);

// ------------------==============

  for (const parcela of parcelasPendentes) {
    await sendMessage(clienteNome, numero, parcela.dataVencimento, temZapData.TeamZapBearer, temZapData.TeamZapUrl, parcela.valor  );
  }
}

}

 return (
    <Container fluid className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
            <h1>TeamZap</h1>
            <Form.Switch
                label={teamZapStatus ? "Ativo" : "Inativo"}
                type="checkbox"
                checked={teamZapStatus}
                onChange={() => setTeamZapStatus(!teamZapStatus)}
                className='ms-2 mb-2 fs-4'
            />
        </div>

        <p className='mt-5 d-flex justify-content-center fs-5'>Esse Recurso é opção, caso tenha interesse, entre em contato com o suporte e adquira já o envio de lembretes automaticos.</p>
        <p className='mt-1 d-flex justify-content-center align-items-center gap-2 fs-5'> 
            <a href="https://wa.me/5588981131487?text=Quero%20adquirir%20o%20teamZap" target='blank'>
            <FaWhatsapp/>
            88 9 8113-1487
            </a>
            
        </p>

        {teamZapStatus && (
            <div>
                <Form onSubmit={()=>{}}>
                    <InputGroup className="mb-3">
                    <label className="input-group-text" >Url</label>
                        <Form.Control
                            type="text"
                            placeholder="Digite a Url da Api"
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                    <label className="input-group-text">Bearer Token</label>
                        <Form.Control
                            type="text"
                            placeholder="**********************"
                        />
                    </InputGroup>

                    <div className='w-full justify-content-end d-flex gap-2'>
                        <Button
                            variant="primary"
                            size="sm"
                            className='py-1 px-4 fs-5 '
                            type='submit'
                        >
                            Salvar
                        </Button>
                        <Button
                            variant="success"
                            size="sm"
                            className='py-1 px-4 fs-5 '
                            onClick={fetchPendingInstallments}

                        >
                            Enviar Lembretes
                        </Button>
                    </div>

                </Form>

            </div>
        )}

    </Container>
 );
}